"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _button = require("../../button");

var _modal = require("../../modal");

var _KeyboardShortcutsBase = require("./KeyboardShortcutsBase");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["close", "closeButtonText", "isOpen", "onClose", "setReturnFocus", "title"];

var KeyboardShortcutsModal = function KeyboardShortcutsModal(_ref) {
  var close = _ref.close,
      _ref$closeButtonText = _ref.closeButtonText,
      closeButtonText = _ref$closeButtonText === void 0 ? 'Close' : _ref$closeButtonText,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      setReturnFocus = _ref.setReturnFocus,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Keyboard Shortcuts' : _ref$title,
      baseProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_modal.Modal, {
    "aria-labelledby": _constants.KEYBOARD_SHORTCUTS_MODAL_ID,
    close: close,
    isOpen: isOpen,
    onClose: onClose,
    setReturnFocus: setReturnFocus
  }, (0, _core.jsx)(_modal.ModalContent, {
    buttons: [(0, _core.jsx)(_button.Button, {
      "aria-describedby": _constants.KEYBOARD_SHORTCUTS_MODAL_ID,
      key: "submit-button",
      onClick: close,
      variant: _button.ButtonVariant.Tertiary
    }, closeButtonText)],
    titleText: title,
    titleTextId: _constants.KEYBOARD_SHORTCUTS_MODAL_ID
  }, (0, _core.jsx)(_KeyboardShortcutsBase.KeyboardShortcutsBase, baseProps)));
};

KeyboardShortcutsModal.displayName = 'KeyboardShortcutsModal';
var _default = KeyboardShortcutsModal;
exports.default = _default;